import React from 'react';

/**
 * Aperçu d'un import ARCHIVÉ : aucune action (Valider, Enregistrer, Archiver…)
 * ne doit être proposée tant qu'il n'est pas désarchivé. Posé par
 * `withArchivedImportGuard` sur chaque route d'aperçu ; lu par `StickyFooter`,
 * qui masque alors les pieds d'action des pages — seul le pied « Désarchiver »
 * (marqué `archivedFooter`) reste affiché.
 */
export const ArchivedPreviewContext = React.createContext<{
  archived: boolean;
}>({ archived: false });
